module.exports = __webpack_public_path__ + "img/popup-icon.b62b37b5.svg";